module.exports = __webpack_public_path__ + "img/cadre.bd10174e.png";